import { render, staticRenderFns } from "./JustificativaAdesaoView.vue?vue&type=template&id=8402deba&scoped=true"
import script from "./JustificativaAdesaoView.vue?vue&type=script&lang=js"
export * from "./JustificativaAdesaoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8402deba",
  null
  
)

export default component.exports